import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DatenabfrageService } from '../../service/datenabfrage/datenabfrage.service';
import { TnbUser } from '../../service/auth/tnb-user';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { ArchivierteDatenabfrage } from '../../domain/model/datenabfrage/archivierte-datenabfrage';
import { DatenabfrageExportService } from '../../service/datenabfrage/datenabfrage-export.service';
import { NotificationService } from '../../service/common/notification/notification.service';

@Component({
    selector: 'tnb-archivierte-datenabfrage-list',
    templateUrl: './archivierte-datenabfrage-list.component.html',
    styleUrls: [
        './archivierte-datenabfrage-list.component.scss',
    ],
    standalone: false,
})
export class ArchivierteDatenabfrageListComponent {
    public isWestnetzUserOrAdmin = false;
    public isWestnetzAdmin = false;
    public tnbUser: TnbUser;

    @Input() archivierteDatenabfragen: ArchivierteDatenabfrage[];
    @Output() archivierteDfChangeds = new EventEmitter<void>();

    private datenabfrageService = inject(DatenabfrageService);
    private datenabfrageExportService = inject(DatenabfrageExportService);
    private notificationService = inject(NotificationService);
    private route = inject(ActivatedRoute);
    private authService = inject(AuthenticationService);

    constructor() {
        this.tnbUser = this.route.snapshot.data.profile;
        this.isWestnetzUserOrAdmin = this.authService.isWestnetzUserOrWestnetzAdmin(this.tnbUser);
        this.isWestnetzAdmin = this.authService.isWestnetzAdmin(this.tnbUser);
    }

    public deleteArchivierteDatenabfrage(datenabfrageId: number) {
        this.datenabfrageService.deleteArchivierteDatenabfrage(datenabfrageId).subscribe(
            () => {
                this.notificationService.success('Die Datenabfrage wurde gelöscht');
                this.archivierteDfChangeds.emit();
            },
        );
    }

    csvExportArchivierteDatenfrage(datenabfrageId: number) {
        this.datenabfrageExportService.exportArchivierteDatenabfrage(datenabfrageId);
    }
}
